export default "__VITE_ASSET__Df5g8HYQ__"